import React, { Fragment, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { SwipeableDrawer, Grid, Typography,  Button,
	 List, ListItem, Switch, Divider, Modal, Backdrop,
         CircularProgress, ListSubheader, IconButton, MenuItem,
	 FormControl, Select } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import firebase from '../../Firebase.js';
import HeaderBar from '../HeaderBar.js';
import MainNavigation from '../MainNavigation.js';
import Exam from './Exam.js';
import { languageOptions, langCodes } from '../../i18n.js';
import { TrainerContext } from '../../contexts/TrainerContext.js';
import { isObjEmpty } from '../../Common.js';
import { AuthContext } from '../../contexts/AuthContext.js';

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      container: {
        [theme.breakpoints.up('sm')] : {
          height: `calc(100% - 64px)`
        },
        [theme.breakpoints.down('xs')] : {
          height: `calc(100% - 56px)`
        },      
      },      
    }),
);

const ExamsFilterMenu  = ({ language, setLanguage, onlyMyClients, setOnlyMyClients, onlyTechnicalIssues, setOnlyTechnicalIssues, getExam, languages, isAuthTrainerOrAdmin }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [ open, setOpen ] = useState(false);
  const openMenu = _ => setOpen(true);
  const closeMenu = _ => setOpen(false);
  var availabelLanguages = languages ? languages : langCodes
  let en_usIndex = availabelLanguages.indexOf("en");
      if (en_usIndex !== -1) {
        availabelLanguages[en_usIndex] = "en-US";
  }
  var trainerLanguagesOptions = languageOptions.filter((item) => availabelLanguages.includes(item.key))  
  
  const getFilteredExam = () => {
    closeMenu();    
    getExam();
  };

  return (
    <Fragment>
      <IconButton
	color='inherit'
	aria-label='open drawer'
	onClick={openMenu}
	className={classes.menuButton}>
	<FilterList />
      </IconButton>
      <SwipeableDrawer
	disableDiscovery
	anchor='right'
	open={open}
	onClose={closeMenu}
	onOpen={openMenu}>
	<List style={{minWidth: '250px'}}>
	  <ListItem>
	    <Grid container alignItems='center'>
	      <Grid item xs={3} />
	      <Grid item xs={6}>
		<Typography align='center' variant='subtitle1'>
		  { t('filter-exams') }
		</Typography>
	      </Grid>
	      <Grid item xs={3}>
		<Button color='secondary'
                        onClick={getFilteredExam}>
		  { t('apply') }
		</Button>
	      </Grid>
	    </Grid>
	  </ListItem>
	  <Divider />
	  <ListItem >
	    <Grid container justify='space-between' alignItems='center'>
	      <Typography variant='body1'>
		{ t('only-my-client') }
	      </Typography>
	      <Switch
		checked={onlyMyClients}
		onChange={(e) => setOnlyMyClients(e.target.checked)}
		className={classes.switchColor} />
	    </Grid>
	  </ ListItem>
    <ListItem >
          <Grid container justify='space-between' alignItems='center'>
            <Typography variant='body1'>
              { t('technical_issue') }
            </Typography>
            <Switch
              checked={onlyTechnicalIssues}
              onChange={(e) => setOnlyTechnicalIssues(e.target.checked)}
              className={classes.switchColor} />
          </Grid>
    </ ListItem>
	  <ListSubheader component='div'>
	    { t('filter-by-lang') }
	  </ListSubheader>          
          <ListItem>
            <FormControl style={{width: '100%'}}>
	      <Select
	        value={language}
	        onChange={(e) => setLanguage(e.target.value)}>
                {[{label: t('all'), key: 'all'}].concat(trainerLanguagesOptions).map((lang) => {
	          return (<MenuItem key={ lang.key } value={ lang.key }> { lang.label }</MenuItem>);
	        })}
	      </Select>
	    </FormControl>
          </ListItem>

	</List>
      </SwipeableDrawer>
    </Fragment>
  );
};


export default () => {
  const classes = useStyles();  
  const { t } = useTranslation();
  const [gettingExam, setGettingExam] = useState(false);
  const [featureExam, setFeaturedExam] = useState(false);

  const [ language, setLanguage ] = useState('all');
  const { authUser } = useContext(AuthContext);
  const [trainer, setTrainer] = useState(authUser);
  const [ onlyMyClients, setOnlyMyClients ] = useState(false);
  const [ onlyTechnicalIssues, setOnlyTechnicalIssues ] = useState(false);

  const { examReasons, pendingExam, numberOfExams, setState } = useContext(TrainerContext);
  const { isAuthTrainerOrAdmin } = useContext(AuthContext);

  const updateExamUi =
        (updatedFields) => setState(s => {
	  return { ...s, pendingExam: { ...s.pendingExam, ...updatedFields }};
        });            
  
  const getExam = async (filters) => {    
    setGettingExam(true);
    try {
      var languages = authUser.languages ? authUser.languages : langCodes;
      let en_usIndex = languages.indexOf("en-US");
      if (en_usIndex !== -1) {
        languages[en_usIndex] = "en";
      }
      if (language !== 'all') {
        languages = [language]
      }
      const pendingExams = await firebase
        .firestore()
        .collection("examBranches")
        .doc("pending")
        .get();
      const exam = await firebase
        .functions()
        .httpsCallable("getExamForTrainer")({ onlyMyClients, onlyTechnicalIssues, languages });
      if (!isObjEmpty(exam.data)) {
        exam.data.submittionDate = new firebase.firestore.Timestamp(
          exam.data.submittionDate._seconds,
          exam.data.submittionDate._nanoseconds
        );
      }
      setState((s) => {
        return {
          ...s,
          pendingExam: exam.data,
          numberOfExams: pendingExams.data().numberOfExams,
        };
      });
    } catch (err) {
      setState((s) => {
        return { ...s, pendingExam: {} };
      });
      console.log(err);
    } finally {
      setGettingExam(false);
    }
  };

  const skipExam = async () => {
    try {
      setGettingExam(true);          
      const showFiveMinLater = 600000;
      const timeMillis = firebase.firestore.Timestamp.now().toMillis() - showFiveMinLater;
      const timeStamp = firebase.firestore.Timestamp.fromMillis(timeMillis);
      await firebase.firestore().doc(pendingExam.docPath).update({ownedByAdminAt: timeStamp});
      getExam();
    }
    catch(err) {
      console.log('error skipping the exam');
    }
  };
  
  const featureVideo = async () => {
    try {
      setFeaturedExam(true);
      await firebase.firestore().doc(pendingExam.docPath).update({featured: true})
      setFeaturedExam(false);
    } catch(err) {
      console.log('error featuring video ', err);
    }
  }

  useEffect(() => {
    if ((pendingExam === null || isObjEmpty(pendingExam)) && trainer != null ) {
      getExam();
    }
  }, []);

  const Title = () => {
    if (language == 'all' && onlyMyClients == false && numberOfExams) {
      return (
        <Typography variant='h6' noWrap align='center'>{t('pending-exams')} ({numberOfExams})</Typography>
        )  
    } else {
      return (
        <Typography variant='h6' noWrap align='center'>{t('pending-exams')}</Typography>
        )        
    }    
  }
  return (
    <Fragment>
      <HeaderBar LComp={<MainNavigation />}
                 MComp={<Title/>}
                 RComp={<ExamsFilterMenu getExam={getExam}
                                         language={language}
                                         languages={authUser.languages}                                         
                                         setLanguage={setLanguage}
                                         onlyMyClients={onlyMyClients}
                                         setOnlyMyClients={setOnlyMyClients}
                                         onlyTechnicalIssues={onlyTechnicalIssues}
                                         setOnlyTechnicalIssues={setOnlyTechnicalIssues}
                                         isAuthTrainerOrAdmin={isAuthTrainerOrAdmin}
                                         />} />
      <div className={classes.container}>
        {
          pendingExam === null || isObjEmpty(examReasons)
            ?        <Modal open={true}
	                    BackdropComponent={Backdrop}
		            disableAutoFocus
		            disableEnforceFocus
	                    BackdropProps={{invisible: true}}>
                       <Grid container justify='center' alignItems='center' style={{height: '100%'}}>
                         <CircularProgress color='secondary'/>
                       </Grid>                       
                     </Modal>
          : <Exam examData={pendingExam}
                  gettingExam={gettingExam}
                  updateExamUi={updateExamUi}
                  skipExam={skipExam}
                  getExam={getExam}
                  featureExam={featureExam}
                  featureVideo={featureVideo}/>
        }
      </div>
    </Fragment>
  );
};
